import React, { useRef, useState } from "react"
import useClickOutside from "../../hooks/useClickOutside";
import classes from "./ActionsPopup.module.css";

const ActionsPopup = ({ children }) => {
    const [showActions, setShowActions] = useState();
    const ref = useRef();

    useClickOutside(ref, () =>
        setShowActions(false)
    );

    return <div className={classes.ActionsPopup} ref={ref}>
        <div className={classes.Dots} onClick={() => setShowActions(prev=>!prev)}>...</div>
        {showActions && <div className={classes.Actions}>{children}</div>}
    </div>
}

const Action = ({ children, onClick }) => {
    return <div className={classes.Action} onClick={onClick}>{children}</div>
}



export { Action, ActionsPopup }